import { ProductNotifyMeRepository } from '../repositories/ProductNotifyMeRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { Product, IProductNotifyMeConfig } from '../domain/entities/Product';

export class LoadProductUseCase {
    private productDetails: IProductNotifyMeConfig;
    private productNotifyMeRepository: ProductNotifyMeRepository;

    constructor(productDetails: IProductNotifyMeConfig) {
        this.productNotifyMeRepository = diContainer.get(serviceNames.productNotifyMeRepository);
        this.productDetails = productDetails;
    }

    public execute = () => {
        const product = Product.FROM_JSON(this.productDetails);
        this.productNotifyMeRepository.setProduct(product);
    };
}
